<button
  data-testid="wishlist-row-card"
  class="card"
  type="button"
  [attr.aria-label]="row().accessibleLabel"
  (click)="handleSelected()"
>
  <ui-avatar
    class="avatar"
    [initials]="beneficiaryInitials()"
    [label]="row().beneficiaryLabel"
    tone="neutral"
    [size]="36"
  />

  <span class="content">
    <span class="heading">
      <span class="title">{{ row().title }}</span>
      @if (row().isPrivate) {
        <span
          class="privacy-lock"
          aria-label="Prywatna lista"
          role="img"
          title="Prywatna lista"
        ></span>
      }
      <svg
        class="chevron"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        aria-hidden="true"
      >
        <path d="m7 4 6 6-6 6" />
      </svg>
    </span>
    <span class="description">{{ row().description }}</span>
    <span class="meta">
      {{ row().beneficiaryLabel }} · {{ row().giftsLabel }}
      @if (hasStatus()) {
        · {{ row().statusLabel }}
      }
    </span>

    @if (row().showReservations !== false) {
      <wishlist-progress-summary
        class="progress"
        [label]="row().progressLabel"
        [value]="row().reservedCount"
        [max]="row().itemsCount"
        [secondaryLabel]="row().pendingLabel"
        [compact]="true"
      />
    }
  </span>
</button>
